import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    offices: [],
    selectedOffice: null,
    isLoading: false
};

const officeSlice = createSlice({
    name: "office",
    initialState,
    reducers: {
        setOffices: (state, action) => {
            state.offices = action.payload;
        },
        setSelectedOffice: (state, action) => {
            state.selectedOffice = action.payload;
        },
        addOffice: (state, action) => {
            state.offices.unshift(action.payload);
        },
        updateOffice: (state, action) => {
            const index = state.offices.findIndex(
                o => o._id === action.payload._id
            );
            if (index !== -1) {
                state.offices[index] = action.payload;
            }
        },
        removeOffice: (state, action) => {
            state.offices = state.offices.filter(
                o => o._id !== action.payload
            );
        }
    }
});

export const {
    setOffices,
    setSelectedOffice,
    addOffice,
    updateOffice,
    removeOffice
} = officeSlice.actions;

export const OfficeReducer = officeSlice.reducer;